import { classNames } from "../../utils"
import { Block, type BlockProps } from "../Block"

export type InlineFlexProps = BlockProps

export function InlineFlex({ className, ...rest }: InlineFlexProps) {
  return <Block className={classNames("inline-flex", className)} {...rest} />
}
